import { useState } from "react";
import { Link } from "react-router-dom";
import { Col, Row } from "reactstrap";
import { NoSidebarData } from "../../../Data/Blog/Blog";
import { Route } from "../../../Routers/RouteList";
import { dynamicImage, Image } from "../../../Utils";
import PageImage from "../../CommonComponents/PageImage";
import SvgIcon from "../../CommonComponents/SvgIcon";

const NoSidebarContainer = () => {
  const [isHeartClicked, setIsHeartClicked] = useState(Array(NoSidebarData.length).fill(false));
  const CardToggle = (index: number) => setIsHeartClicked((prevState) => prevState.map((item, i) => (i === index ? !item : item)));
  return (
    <section className="section-py-space blog-page ratio2_3">
      <PageImage />
      <div className="custom-container">
        <Row className="g-4">
          {NoSidebarData.map((item, index) => (
            <Col md="6" xl="3" key={index}>
              <div className="blog-side">
                <div className="blog-box blog-grid">
                  <Image className="img-fluid top-radius-blog" src={dynamicImage(`blog/blog-${item.image}.jpg`)} alt="blog" />
                  <div className="blog-details-main">
                    <div className="d-flex gap-2 align-items-center">
                      <div className="flex-shrink-0">
                        <Image className="img-fluid" src={dynamicImage(`about/${item.avatar}.png`)} alt="avatar" />
                      </div>
                      <div className="flex-grow-1">
                        <h5>{item.title}</h5>
                        <p className="mb-0">{item.date}</p>
                      </div>
                      <i className="fa fa-ellipsis-v" />
                    </div>
                    <h3 className="f-w-600">{item.text}</h3>
                    <p className="blog-bottom-details">
                      {item.content}
                      <Link className="font-danger" to={Route.SidebarDetails}>
                        Read more...
                      </Link>
                    </p>
                    <ul className="blog-social d-flex gap-3 justify-content-between">
                      <li>{item.views}k views</li>
                      <li className={`${isHeartClicked[index] ? "clicked" : "initial"}-color`} onClick={() => CardToggle(index)}>
                        <SvgIcon iconId="heart" />
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </Col>
          ))}
        </Row>
      </div>
    </section>
  );
};

export default NoSidebarContainer;
